import { NewSuitabilityData } from 'src/suitability-report/types';

/**
 * Extracts the client ID from suitability flow data.
 * When a family is selected, returns the main family member's client ID.
 * When a client is selected, returns the client ID directly.
 */
export function getClientId(data: NewSuitabilityData): string | undefined {
  return data.isFamily ? data.family?.mainFamilyMember.clientId : data.client?.id;
}
